<script>
import InfiniteLoading from 'vue-infinite-loading'

import api from '@/api'
import { getErrors } from '@/errors'

export default {
  name: 'ChildNotesDialog',

  components: {
    InfiniteLoading
  },

  props: ['child'],

  data () {
    return {
      notes: [],

      isFormVisible: false,
      isSubmitting: false,
      text: ''
    }
  },

  methods: {
    close () {
      this.$emit('close')
    },

    fetchMore (state) {
      const limit = 10
      const offset = this.notes.length

      api.get('/child-notes/', {
        params: {
          child: this.child.id,
          limit,
          offset
        }
      })
        .then(response => {
          this.notes = this.notes.concat(response.data.results)

          if (response.data.results.length > 0) {
            state.loaded()
          }
          if (offset + response.data.results.length >= response.data.count) {
            state.complete()
          }
        }, error => {
          state.complete()
          this.$toast.error(getErrors(error).detail)
        })
    },

    toggleForm () {
      this.isFormVisible = !this.isFormVisible
    },

    submitForm () {
      this.isSubmitting = true

      api.post('/child-notes/', {
        child: this.child.id,
        text: this.text
      })
        .then(response => {
          this.notes = [response.data, ...this.notes]

          this.isFormVisible = false
          this.text = ''

          this.$toast.success('Комментарий добавлен')
        }, error => {
          this.$toast.error(getErrors(error).detail)
        })
        .then(() => {
          this.isSubmitting = false
        })
    }
  }
}
</script>

<template>
  <div class="dialog-wrapper">
    <div class="dialog-overlay" @click="close"></div>
    <div class="dialog-box notes-dialog-box">
      <div class="dialog-header">
        <div class="dialog-header-text">
          {{ child.last_name }} {{ child.first_name }}
          <div class="dialog-header-text-subtitle">Комментарии</div>
        </div>
        <BaseCloseButton @click="close" />
      </div>
      <div class="dialog-content notes-dialog-content">
        <div class="note-form-wrapper">
          <button
            v-if="!isFormVisible"
            @click="toggleForm"
            class="button green no-margin"
          >
            Добавить комментарий
          </button>
          <form v-if="isFormVisible" @submit.prevent="submitForm">
            <textarea
              class="form-input text-area"
              v-model="text"
              v-focus
              :disabled="isSubmitting"
              spellcheck
            ></textarea>
            <button
              type="submit"
              class="button no-margin"
              :disabled="isSubmitting || !text"
            >
              Отправить
            </button>
          </form>
        </div>
        <div class="notes">
          <div v-for="note in notes" :key="note.id" class="note">
            <div class="note-text">{{ note.text }}</div>
            <div class="note-footer">
              <div class="note-signature">
                <div class="note-date">{{ $utils.formatDateTime(note.date_created) }}</div>
                <div class="note-name">{{ note.created_by }}</div>
              </div>
            </div>
          </div>
          <InfiniteLoading @infinite="fetchMore" spinner="spiral">
            <template #no-more>Больше нет комментариев.</template>
            <template #no-results>Нет комментариев.</template>
          </InfiniteLoading>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.notes-dialog-box {
  width: 40em;
  /*background-color: var(--light-gray);*/
}

.notes-dialog-content {
  max-height: 70vh;

  display: flex;
  flex-direction: column;

/*  margin: 0 0.75em 0.75em 0.75em;*/
/*  background-color: white;*/
/*  padding: 1.5em 0.75em;*/
/*  border-radius: 0.75em;*/
/*  height: 60vh;*/
}

.note-form-wrapper {
  margin-bottom: 1em;
}

.text-area {
  width: 100%;
  height: 10em;

  font-family: inherit;
  font-size: inherit;

  resize: none;

  color: var(--dark-text);
  padding: 0.8em 1em;
  margin: 0 0 1em 0;
  text-align: left;
  font-weight: normal;
  border: 1px solid var(--medium-gray);
}

.notes {
  flex: 1;

  overflow: auto;
}

.note {
  background: var(--light-gray);
  padding: 1em;
  margin-bottom: 1em;
  border-radius: 1em;
}

.note-text {
  margin-bottom: 0.75em;
  white-space: pre-wrap;
}

.note-footer {
  display: flex;
  align-items: baseline;
}

.note-signature {
  font-size: 80%;
  display: flex;
  flex: 1;
  white-space: nowrap;
  width: 100%;
}

.note-date::after {
  content: "/";
  margin: 0 10px;
}

.note-name {
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
